// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import BusinessNew from '../_raw/service/icon_business_new.svg';
import withIconProps from '../withIconProps';

export default withIconProps(BusinessNew);
